import { Storage } from '../lib/storage';
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Store, MapPin, Search, Star, MessageSquarePlus, Clock, PenTool, CheckCircle, Camera, FileText, Loader2, X } from 'lucide-react';
import { supabase } from '../lib/supabase';

export default function MercadoScreen() {
  const [modalLicitacionAbierto, setModalLicitacionAbierto] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [detalleSolicitud, setDetalleSolicitud] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [tallerParaCotizar, setTallerParaCotizar] = useState<any>(null);
  const [tallerParaFicha, setTallerParaFicha] = useState<any>(null);

  const [myCoords, setMyCoords] = useState<{lat: number, lon: number} | null>(null);
  const [pidiendoGPS, setPidiendoGPS] = useState(false);

  const pedirGPS = () => {
     if (!navigator.geolocation) return alert("Tu dispositivo no soporta GPS.");
     setPidiendoGPS(true);
     navigator.geolocation.getCurrentPosition((pos) => {
        setMyCoords({ lat: pos.coords.latitude, lon: pos.coords.longitude });
        setPidiendoGPS(false);
     }, () => {
        alert("Activa el GPS en tu celular y dale permisos a la app para usar esta función.");
        setPidiendoGPS(false);
     }, { enableHighAccuracy: true });
  };

  const getDistanceFromLatLonInKm = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    var R = 6371; 
    var dLat = (lat2-lat1) * (Math.PI/180);
    var dLon = (lon2-lon1) * (Math.PI/180); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1*(Math.PI/180)) * Math.cos(lat2*(Math.PI/180)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    return (R * c); 
  };
  // Estados Formulario Taller
  const [esTaller, setEsTaller] = useState(false);
  const [tallerEnviado, setTallerEnviado] = useState(false);

  // Utilidad de Capitalización
  const formatSentenceCase = (text: string) => {
    if (!text) return text;
    return text.replace(/(^\s*|\.\s+|\n\s*)([a-zñáéíóú])/gi, (match, prefix, letter) => {
      return prefix + letter.toUpperCase();
    });
  };
  const [nombreTaller, setNombreTaller] = useState('');
  const [nitTaller, setNitTaller] = useState('');
  const [archivos, setArchivos] = useState<{[key: string]: File | null}>({
    cedula: null,
    camara: null,
    rut: null,
    recibo: null
  });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    if (e.target.files && e.target.files[0]) {
      const f = e.target.files[0];
      if (f.size > 512 * 1024) {
        alert("⚠️ El archivo "+f.name+" pesa "+(f.size/1024).toFixed(0)+"KB, excediendo el límite de 512KB. Comprímelo o toma una foto de menor resolución y vuelve a intentarlo.");
        e.target.value = '';
        return;
      }
      setArchivos(prev => ({...prev, [key]: f}));
    }
  };

  const enviarLicitacion = async () => {
    if (!detalleSolicitud) return alert("Escribe lo que necesitas para tu moto.");
    setLoading(true);
    try {
       const myId = Storage.get('gravity_user_id');
       if (!myId) throw new Error("Sesión no válida");
       
       const payload = {
          motero_id: myId,
          taller_id: tallerParaCotizar ? tallerParaCotizar.id : null,
          detalle_solicitud: detalleSolicitud,
          estado: 'abierta'
       };

       const { error } = await supabase.from('cotizaciones').insert([payload]);
       if (error) throw error;

       setEnviado(true);
    } catch(e: any) {
       console.error(e);
       alert("Error al enviar la licitación. Asegúrate de haber creado la tabla 'cotizaciones' en Supabase.");
    } finally {
       setLoading(false);
    }
  };

  const handlePostularTaller = async () => {
    if (!nombreTaller.trim() || !nitTaller.trim()) {
      alert("⚠️ Por favor, ingresa el Nombre de tu Taller y tu NIT/Cédula en los campos.");
      return;
    }

    if (!archivos.cedula || !archivos.camara || !archivos.rut || !archivos.recibo) {
      alert("⚠️ Faltan documentos obligatorios. Por favor, sube los 4 archivos solicitados para continuar.");
      return;
    }

    const myId = Storage.get('gravity_user_id');
    if (!myId) {
      alert("Sesión no válida o expirada.");
      return;
    }

    setLoading(true);

    try {
      // 1. Validar la Regla de "Un Taller por Cédula/Celular"
      const { data: solPrevia } = await supabase.from('solicitudes_taller').select('id').eq('usuario_id', myId).eq('estado', 'pendiente').limit(1);
      const { data: tallerPrevio } = await supabase.from('talleres_aliados').select('id').eq('usuario_id', myId).limit(1);

      if ((solPrevia && solPrevia.length > 0) || (tallerPrevio && tallerPrevio.length > 0)) {
        alert("🛑 NEGADO: Solo se permite poseer un (1) Taller por Motero/Cédula. Ya tienes una vinculación activa o una solicitud en trámite de verificación.");
        setLoading(false);
        return;
      }

      const getExtension = (f: File) => {
        if (!f) return 'jpg';
        const name = f.name.toLowerCase();
        if (f.type.includes('pdf') || name.endsWith('pdf')) return 'pdf';
        if (f.type.includes('png') || name.endsWith('png')) return 'png';
        return 'jpg';
      };
      const getMimeType = (f: File) => {
        if (!f || !f.type) return 'application/octet-stream';
        return f.type;
      };
      const toBase64 = (file: File) => new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          let base64 = (reader.result as string).split(',')[1];
          // Remove any newline or blank spaces just in case
          base64 = base64.replace(/\s/g, '');
          resolve(base64);
        };
        reader.onerror = error => reject(error);
      });

      const userStr = Storage.get('gravity_user');
      const myPhone = userStr ? JSON.parse(userStr).celular : '';

      const nit = nitTaller.trim();
      const payload = {
        nombre: nombreTaller,
        nit: nit,
        celular: myPhone,
        archivos: [
          { name: "Cedula_"+nit+"."+getExtension(archivos.cedula as File), type: getMimeType(archivos.cedula as File), data: await toBase64(archivos.cedula as File) },
          { name: "CamaraComercio_"+nit+"."+getExtension(archivos.camara as File), type: getMimeType(archivos.camara as File), data: await toBase64(archivos.camara as File) },
          { name: "RUT_"+nit+"."+getExtension(archivos.rut as File), type: getMimeType(archivos.rut as File), data: await toBase64(archivos.rut as File) },
          { name: "ReciboPublico_"+nit+"."+getExtension(archivos.recibo as File), type: getMimeType(archivos.recibo as File), data: await toBase64(archivos.recibo as File) }
        ]
      };

      await fetch("https://script.google.com/macros/s/AKfycbyUebMoi25UCpX7_gIs-CpnwmdAbYCLPh4MD1DZEM380J6Gq3LI6UAw68_MSXF-8boT_w/exec", {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload)
      });
      
      // Enviar registro oculto a Supabase para tener la trazabilidad
      await supabase.from('solicitudes_taller').insert([{
         usuario_id: myId,
         nombre_taller: nombreTaller,
         nit: nit,
         estado: 'pendiente'
      }]);

      setTallerEnviado(true);
    } catch (e) {
      alert("Hubo un error de red al subir la información. Tu documento es pesado, verifica conexión.");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const [talleresORO, setTalleresORO] = useState<any[]>([]);
  const [cargandoTalleres, setCargandoTalleres] = useState(true);

  // Traer los talleres aprobados desde Supabase
  useEffect(() => {
    const fetchTalleres = async () => {
      try {
        const { data, error } = await supabase
          .from('talleres_aliados')
          .select('*')
          .gte('rating', 0)
          .order('rating', { ascending: false })
          .limit(20);
        
        if (error) throw error;
        
        if (data) {
          // Bloquear visibilidad para talleres con penalidad por evasión (>= 3 ofertas no finalizadas)
          const { data: cotis } = await supabase
            .from('cotizaciones')
            .select('taller_id')
            .eq('estado', 'respondida');
            
          let morosos: Record<string, number> = {};
          if (cotis) {
            cotis.forEach((c: any) => {
               if (c.taller_id) {
                 morosos[c.taller_id] = (morosos[c.taller_id] || 0) + 1;
               }
            });
          }
          
          const talleresSanos = data.filter((t: any) => (morosos[t.id] || 0) < 3);
          setTalleresORO(talleresSanos.slice(0, 5));
        }
      } catch (e) {
        console.error("Error cargando talleres:", e);
      } finally {
        setCargandoTalleres(false);
      }
    };
    fetchTalleres();
  }, []);

  if (tallerEnviado) {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="flex flex-col items-center justify-center p-6 text-center h-full">
        <CheckCircle className="w-16 h-16 text-green-400 mb-4" />
        <h2 className="text-xl font-bold mb-2">¡Documentación Enviada!</h2>
        <p className="text-text-muted text-sm border-b border-white/10 pb-6 mb-6">Nuestro equipo verificará tu Cámara de Comercio y RUT. Pronto aparecerás en este directorio.</p>
        <button onClick={() => {setEsTaller(false); setTallerEnviado(false);}} className="text-primary-cyan underline font-bold uppercase text-xs tracking-widest">
          Volver al Mercado
        </button>
      </motion.div>
    );
  }

  if (esTaller) {
    return (
      <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="flex flex-col space-y-4">
        <h2 className="text-xl font-extrabold text-gold-cert mb-1 flex items-center gap-2"><Store className="w-5 h-5"/> Aplícate como Taller Aliado</h2>
        <p className="text-text-muted text-[11px] pb-2 leading-tight">Para cotizar repuestos B2B a moteros de Pikis Hub, debes probar que tu negocio es real subiendo soporte legal.</p>

        <div className="bg-danger-red/10 border border-danger-red/30 p-3 rounded-lg mb-2">
          <p className="text-danger-red text-[11px] font-bold flex items-center gap-1 uppercase tracking-widest"><FileText className="w-3 h-3"/> Normativa de Subida</p>
          <p className="text-white/80 text-[10px] leading-tight">Todos los archivos son obligatorios. Peso máximo permitido: <strong className="text-white">512KB</strong> por documento.</p>
        </div>

        <div className="space-y-3 pb-6">
          <div className="flex flex-col space-y-1">
            <label className="text-[10px] text-gold-cert font-bold uppercase tracking-wider pl-1">Nombre Comercial del Taller</label>
            <input 
              type="text" 
              placeholder="Ej. MOTOS EL PARCHE" 
              value={nombreTaller}
              onChange={e => setNombreTaller(e.target.value.toUpperCase())}
              className="w-full px-4 py-3 rounded-xl border border-white/10 bg-slate-800/50 text-white outline-none focus:border-gold-cert text-[13px] font-bold uppercase transition-colors" 
            />
          </div>

          <div className="flex flex-col space-y-1 mb-2">
            <label className="text-[10px] text-gold-cert font-bold uppercase tracking-wider pl-1">NUMERO DE NIT</label>
            <input 
              type="tel" 
              placeholder="Ej. 900111222" 
              value={nitTaller}
              onChange={e => setNitTaller(e.target.value.replace(/\D/g, ''))}
              className="w-full px-4 py-3 rounded-xl border border-white/10 bg-slate-800/50 text-white outline-none focus:border-gold-cert text-[13px] font-bold tracking-[3px] transition-colors" 
            />
          </div>

          <label className="w-full bg-slate-800/80 border border-white/5 p-4 rounded-xl flex items-center justify-between text-sm active:scale-95 transition-all text-left cursor-pointer">
            <div className="flex items-center gap-3">
              <Camera className="w-5 h-5 text-gold-cert" />
              <div>
                <strong className="block text-white">Cédula Rep. Legal</strong>
                <span className="text-[10px] text-text-muted">{archivos.cedula ? <span className="text-green-400">{archivos.cedula.name}</span> : 'Tomar foto (Frente y Reverso)'}</span>
              </div>
            </div>
            {archivos.cedula && <CheckCircle className="w-5 h-5 text-green-400" />}
            <input type="file" accept="image/*,application/pdf" className="hidden" onChange={(e) => handleFileChange(e, 'cedula')} />
          </label>

          <label className="w-full bg-slate-800/80 border border-white/5 p-4 rounded-xl flex items-center justify-between text-sm active:scale-95 transition-all text-left cursor-pointer">
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-gold-cert" />
              <div>
                <strong className="block text-white">Cámara de Comercio</strong>
                <span className="text-[10px] text-text-muted">{archivos.camara ? <span className="text-green-400">{archivos.camara.name}</span> : 'Adjuntar PDF (No mayor a 30 días)'}</span>
              </div>
            </div>
            {archivos.camara && <CheckCircle className="w-5 h-5 text-green-400" />}
            <input type="file" accept="image/*,application/pdf" className="hidden" onChange={(e) => handleFileChange(e, 'camara')} />
          </label>

          <label className="w-full bg-slate-800/80 border border-white/5 p-4 rounded-xl flex items-center justify-between text-sm active:scale-95 transition-all text-left cursor-pointer">
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-gold-cert" />
              <div>
                <strong className="block text-white">RUT Actualizado</strong>
                <span className="text-[10px] text-text-muted">{archivos.rut ? <span className="text-green-400">{archivos.rut.name}</span> : 'Adjuntar PDF de la DIAN'}</span>
              </div>
            </div>
            {archivos.rut && <CheckCircle className="w-5 h-5 text-green-400" />}
            <input type="file" accept="image/*,application/pdf" className="hidden" onChange={(e) => handleFileChange(e, 'rut')} />
          </label>

          <label className="w-full bg-slate-800/80 border border-white/5 p-4 rounded-xl flex items-center justify-between text-sm active:scale-95 transition-all text-left cursor-pointer">
            <div className="flex items-center gap-3">
              <Camera className="w-5 h-5 text-gold-cert" />
              <div>
                <strong className="block text-white">Recibo Público Reciente</strong>
                <span className="text-[10px] text-text-muted">{archivos.recibo ? <span className="text-green-400">{archivos.recibo.name}</span> : 'Verificación del domicilio (Geovalla)'}</span>
              </div>
            </div>
            {archivos.recibo && <CheckCircle className="w-5 h-5 text-green-400" />}
            <input type="file" accept="image/*,application/pdf" className="hidden" onChange={(e) => handleFileChange(e, 'recibo')} />
          </label>
        </div>

        <div className="pt-4 flex flex-col gap-2">
          <button onClick={handlePostularTaller} disabled={loading} className="w-full p-4 bg-gold-cert text-yellow-950 rounded-xl font-black text-base hover:shadow-[0_0_20px_#fbbf24] transition-all">
            {loading ? 'Subiendo datos seguros...' : 'Enviar a Auditoría Pikis Hub'}
          </button>
          <button onClick={() => setEsTaller(false)} className="mx-auto mt-2 text-text-muted hover:text-white uppercase font-bold text-[10px] tracking-widest transition-colors">
            Cancelar
          </button>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col h-full relative"
    >
      {/* LINK MOVIDO A LA PARTE SUPERIOR DEL MERCADO */}
      <div className="bg-gold-cert/10 border border-gold-cert/30 rounded-xl p-3 mb-5 flex justify-between items-center">
        <div className="flex flex-col">
          <span className="text-gold-cert text-[10px] font-black uppercase tracking-widest">Atención Empresas</span>
          <span className="text-xs text-white">¿Eres dueño de un Taller?</span>
        </div>
        <button 
          onClick={() => setEsTaller(true)}
          className="bg-gold-cert text-yellow-950 font-bold text-[10px] uppercase px-3 py-1.5 rounded-lg active:scale-95 transition-transform"
        >
          Postúlate Aquí
        </button>
      </div>

      <div className="mb-4">
        <h2 className="text-xl font-extrabold flex items-center gap-2">
          <Store className="w-6 h-6 text-primary-cyan" /> Directorio de Aliados
        </h2>
        <p className="text-text-muted text-[13px] border-b border-white/5 pb-4">
          Red de talleres y grúas verificadas por <span className="font-bold text-white">PIKIS HUB</span>.
        </p>
      </div>

      {/* Botón Principal: Crear Licitación BALANCEADO */}
      <button 
        onClick={() => { setTallerParaCotizar(null); setModalLicitacionAbierto(true); }}
        className="relative overflow-hidden shrink-0 group w-full bg-gradient-to-r from-blue-600 to-primary-cyan text-white py-3.5 px-5 rounded-2xl mb-6 flex justify-between items-center shadow-[0_5px_15px_rgba(59,130,246,0.2)] active:scale-95 transition-all"
      >
        <div className="absolute -right-5 -top-5 w-24 h-24 bg-white/20 rounded-full blur-xl group-hover:bg-white/30 transition-colors"></div>
        <div className="text-left relative z-10 w-[80%]">
          <h3 className="font-black text-[15px] mb-0.5 drop-shadow-md leading-none">¿Buscas un Repuesto?</h3>
          <p className="text-[10px] text-white/90 leading-tight">Publica tu necesidad y recibe cotizaciones cercanas.</p>
        </div>
        <div className="w-10 h-10 bg-white text-blue-600 rounded-full flex items-center justify-center shrink-0 shadow-md group-hover:rotate-12 transition-transform">
          <MessageSquarePlus className="w-5 h-5" />
        </div>
      </button>

      {/* Buscador y Filtros */}
      <div className="relative mb-3 shadow-[0_4px_20px_rgba(0,0,0,0.2)] rounded-xl">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <Search className="w-4 h-4 text-slate-400" />
        </div>
        <input 
          type="text" 
          placeholder="Buscar talleres, llantas, aceites..." 
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          onKeyDown={(e) => {
             if (e.key === 'Enter' && busqueda) {
               const filtrados = talleresORO.filter(t => t.nombre.toLowerCase().includes(busqueda.toLowerCase()) || (t.especialidad && t.especialidad.toLowerCase().includes(busqueda.toLowerCase())));
               if (filtrados.length === 0) {
                 window.open('https://www.google.com/search?q=' + encodeURIComponent(busqueda + " taller de motos"), '_blank');
               }
             }
          }}
          className="w-full pl-11 pr-4 py-3 bg-slate-800/90 border border-slate-600 rounded-xl text-sm font-bold text-white outline-none focus:border-gold-cert focus:bg-slate-800 transition-all placeholder:text-slate-500"
        />
      </div>

      {/* Botón Táctico de Radar Manual (Fase 3) */}
      <button 
         onClick={pedirGPS}
         disabled={pidiendoGPS}
         className="w-full bg-slate-800/80 border border-gold-cert/50 text-gold-cert mb-6 py-1.5 px-2 rounded-xl flex items-center justify-center gap-1.5 font-black uppercase text-[10px] tracking-wide whitespace-nowrap active:scale-95 transition-all shadow-[0_0_10px_rgba(251,191,36,0.1)]"
      >
         {pidiendoGPS && <Loader2 className="w-4 h-4 animate-spin shrink-0" />}
         <span className="truncate">{pidiendoGPS ? 'Calculando Coordenadas...' : '📍 Calcular Distancias Reales desde Mi Ubicación'}</span>
      </button>

      {/* Lista de Talleres */}
      <div className="space-y-4 pb-20">
        {cargandoTalleres ? (
          <div className="flex flex-col items-center justify-center py-10 opacity-70">
            <Loader2 className="w-8 h-8 text-gold-cert animate-spin mb-3" />
            <p className="text-xs font-bold text-gold-cert uppercase tracking-widest">Sincronizando Radar...</p>
          </div>
        ) : (
          (() => {
            const filtrados = talleresORO.filter(t => t.nombre.toLowerCase().includes(busqueda.toLowerCase()) || (t.especialidad && t.especialidad.toLowerCase().includes(busqueda.toLowerCase())));
            
            if (filtrados.length === 0) {
              if (busqueda) {
                return (
                  <div className="text-center py-10 bg-slate-800/40 rounded-2xl border border-white/5 mx-2">
                    <Search className="w-10 h-10 text-white/20 mx-auto mb-3" />
                    <p className="text-slate-400 text-sm font-bold mb-3">No hay talleres afiliados para "{busqueda}".</p>
                    <button 
                      onClick={() => window.open('https://www.google.com/search?q=' + encodeURIComponent(busqueda + " taller de motos"), '_blank')}
                      className="bg-primary-cyan/20 text-primary-cyan font-bold py-2 px-6 rounded-xl border border-primary-cyan/40 hover:bg-primary-cyan hover:text-bg-dark transition-all"
                    >
                      Buscar en Google
                    </button>
                  </div>
                );
              } else {
                return (
                  <div className="text-center py-10 bg-slate-800/40 rounded-2xl border border-white/5 mx-2">
                    <Store className="w-10 h-10 text-white/20 mx-auto mb-3" />
                    <p className="text-slate-400 text-sm font-bold">Aún no hay Talleres SCORE ORO en tu zona.</p>
                    <p className="text-slate-500 text-xs mt-1">Si conoces uno, dile que se postule.</p>
                  </div>
                );
              }
            }

            return filtrados.map((taller) => (
              <div key={taller.id} className="bg-slate-800/60 border border-white/10 rounded-2xl p-4 hover:border-gold-cert/50 transition-colors flex flex-col relative overflow-hidden">
                <div className="absolute top-0 right-0 p-3">
                  <span className={`text-[9px] font-black uppercase px-2 py-1 rounded-full ${taller.open ? 'bg-green-500/20 text-green-400' : 'bg-danger-red/20 text-danger-red'}`}>
                    {taller.open ? 'Abierto' : 'Cerrado'}
                  </span>
                </div>

                <h4 className="font-extrabold text-[15px] text-white flex items-center gap-1.5 mb-1 pr-16">{taller.nombre}</h4>
                <span className="text-gold-cert text-[10px] font-bold uppercase tracking-widest flex items-center gap-1 mb-3">
                  <Star className="w-3 h-3 fill-gold-cert" /> SCORE ORO ({taller.rating})
                </span>
                
                <p className="text-[12px] text-text-muted mb-4 border-l-2 border-slate-700 pl-2 leading-tight">
                  {taller.especialidad}
                </p>

                <div className="flex justify-between items-center pt-3 border-t border-white/5">
                  <button 
                    onClick={() => setTallerParaFicha(taller)}
                    className="text-[11px] text-zinc-400 font-bold flex items-center gap-1 hover:text-primary-cyan transition-colors text-left"
                  >
                    <MapPin className="w-3 h-3 shrink-0" /> 
                    {myCoords && taller.latitud != null ? 
                       `📍 A ${(getDistanceFromLatLonInKm(myCoords.lat, myCoords.lon, taller.latitud, taller.longitud)).toFixed(1)} km de ti` 
                       : (taller.ciudad ? `📍 ${taller.ciudad}` : '📍 Taller Base')}
                  </button>
                  <div className="flex gap-2 shrink-0">
                    <button 
                      onClick={() => setTallerParaFicha(taller)}
                      className="text-[10px] bg-white/5 hover:bg-white/10 text-white font-bold py-1.5 px-3 rounded-lg border border-white/10 transition-colors"
                    >
                      Ver Ficha
                    </button>
                    <button 
                      onClick={() => { setTallerParaCotizar(taller); setModalLicitacionAbierto(true); }}
                      className="text-[10px] bg-primary-cyan/20 hover:bg-primary-cyan text-primary-cyan hover:text-bg-dark border border-primary-cyan/30 font-bold py-1.5 px-3 rounded-lg transition-all"
                    >
                      Cotizar
                    </button>
                  </div>
                </div>
              </div>
            ));
          })()
        )}
      </div>

      {/* Modal Licitación */}
      <AnimatePresence>
        {modalLicitacionAbierto && (
          <motion.div 
            initial={{ opacity: 0, y: '100%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '100%' }}
            className="fixed inset-0 z-[80] bg-[#0f172a] p-6 flex flex-col"
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-black text-white flex items-center gap-2">
                <PenTool className="w-6 h-6 text-primary-cyan" />
                {tallerParaCotizar ? 'Cotizar Servicio' : 'Licitación Nacional'}
              </h2>
              <button onClick={() => setModalLicitacionAbierto(false)} className="text-text-muted font-bold text-sm">Cerrar</button>
            </div>

            {tallerParaCotizar && !enviado && (
               <div className="bg-primary-cyan/10 border border-primary-cyan/20 p-3 rounded-xl mb-4 text-[11px] font-bold text-primary-cyan flex items-center gap-2">
                  <Store className="w-4 h-4 shrink-0" /> Solicitud directa para: {tallerParaCotizar.nombre}
               </div>
            )}

            {enviado ? (
              <div className="flex-1 flex flex-col items-center justify-center text-center">
                <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center mb-6">
                  <CheckCircle className="w-12 h-12 text-green-400" />
                </div>
                <h3 className="text-xl font-bold mb-2">¡Solicitud Transmitida!</h3>
                <p className="text-text-muted text-sm mb-8">
                  {tallerParaCotizar 
                    ? `Tu solicitud fue enviada directamente al tablero de ${tallerParaCotizar.nombre}. Será respondida en breve.` 
                    : 'Tu solicitud está sonando en los computadores y celulares de todos los talleres SCORE ORO en un radio de 5km.'
                  }
                </p>
                
                <div className="bg-blue-500/10 border border-blue-500/20 p-4 rounded-2xl w-full text-left">
                  <p className="text-[11px] text-blue-400 font-bold mb-1 flex items-center gap-1"><Clock className="w-3 h-3" /> Estado Actual</p>
                  <p className="text-xs text-white">Esperando cotizaciones de los mecánicos...</p>
                </div>

                <button 
                  onClick={() => { setModalLicitacionAbierto(false); setEnviado(false); setDetalleSolicitud(''); }}
                  className="mt-auto w-full py-4 bg-primary-cyan font-black text-white rounded-xl active:scale-95 transition-transform"
                >
                  Volver al Directorio
                </button>
              </div>
            ) : (
              <div className="flex flex-col flex-1">
                <label className="text-xs font-bold text-primary-cyan uppercase mb-2">¿Qué repuesto o servicio necesitas?</label>
                <textarea 
                  className="w-full bg-slate-800/80 border border-slate-700 rounded-2xl p-4 text-white text-sm outline-none focus:border-gold-cert resize-none mb-4"
                  rows={5}
                  placeholder="Ej: Necesito un Kit de Arrastre original para NS200. Estoy varado cerca al peaje de Chusacá... ¿Quién tiene y cuánto vale con instalación?"
                  value={detalleSolicitud}
                  onChange={(e) => setDetalleSolicitud(formatSentenceCase(e.target.value))}
                ></textarea>

                <div className="bg-gold-cert/10 border border-gold-cert/30 p-4 rounded-xl text-left mb-auto">
                   <p className="text-[10px] text-gold-cert font-black uppercase tracking-wide mb-1 flex items-center gap-1"><Star className="w-3 h-3" /> Privacidad Garantizada</p>
                   <p className="text-[10px] text-text-muted leading-tight">Tu número de teléfono NO será visible para los talleres. Ellos enviarán su precio de subasta a través de Pikis Hub.</p>
                </div>

                <button 
                  onClick={enviarLicitacion}
                  disabled={loading}
                  className="w-full mt-4 py-3.5 bg-gradient-to-r from-blue-600 to-primary-cyan text-white font-extrabold text-sm rounded-xl shadow-[0_10px_30px_rgba(59,130,246,0.3)] active:scale-95 transition-all text-center"
                >
                  {loading ? 'Ondeando Radar...' : 'Hacer Solicitud Nacional'}
                </button>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal Ver Ficha de Taller */}
      <AnimatePresence>
        {tallerParaFicha && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="fixed inset-0 z-[90] bg-[#0f172a]/95 backdrop-blur-md flex flex-col justify-center px-6"
          >
            <div className="bg-slate-800 border border-white/10 rounded-3xl p-6 relative overflow-hidden shadow-2xl">
               <button onClick={() => setTallerParaFicha(null)} className="absolute top-4 right-4 p-2 bg-white/5 rounded-full hover:bg-white/10 text-white transition-colors">
                 <X className="w-5 h-5" />
               </button>
               
               <div className="w-16 h-16 bg-gold-cert/10 rounded-full flex items-center justify-center border border-gold-cert/30 mb-4 shadow-[0_0_20px_rgba(251,191,36,0.15)]">
                 <Store className="w-8 h-8 text-gold-cert" />
               </div>

               <h3 className="text-2xl font-black text-white leading-tight mb-1">{tallerParaFicha.nombre}</h3>
               <span className="text-gold-cert text-[10px] font-bold uppercase tracking-widest flex items-center gap-1 mb-5">
                 <Star className="w-3.5 h-3.5 fill-gold-cert" /> Aliado SCORE ORO ({tallerParaFicha.rating})
               </span>
               
               <div className="space-y-4 text-sm mb-8">
                  <div>
                    <label className="text-[10px] text-primary-cyan uppercase font-black tracking-widest block mb-1">Especialidad</label>
                    <p className="text-white font-medium leading-tight">{tallerParaFicha.especialidad}</p>
                  </div>
                  {(tallerParaFicha.ciudad || tallerParaFicha.direccion) && (
                  <div className="mb-4">
                    <label className="text-[10px] text-primary-cyan uppercase font-black tracking-widest block mb-1">Ubicación Física</label>
                    <p className="text-white font-medium flex items-start gap-2 mb-4">
                       <MapPin className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" /> 
                       <span>{tallerParaFicha.ciudad ? tallerParaFicha.ciudad + ' - ' : ''} {tallerParaFicha.direccion || ''}</span>
                    </p>

                    {/* FASES 4: Catapulta Externa a GPS (Costo $0) */}
                    <div className="flex gap-2">
                        <a 
                          href={tallerParaFicha.latitud != null ? `https://waze.com/ul?ll=${tallerParaFicha.latitud},${tallerParaFicha.longitud}&navigate=yes` : `https://waze.com/ul?q=${encodeURIComponent((tallerParaFicha.nombre + ' ' + (tallerParaFicha.ciudad||'')).trim() + ', Colombia')}&navigate=yes`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 py-3 bg-blue-500/20 text-blue-400 hover:bg-blue-500 hover:text-white border border-blue-500/40 rounded-xl text-[11px] font-black uppercase tracking-widest flex items-center justify-center gap-1.5 transition-all shadow-inner"
                        >
                           🚀 Ir con Waze
                        </a>
                        <a 
                          href={tallerParaFicha.latitud != null ? `https://maps.google.com/?q=${tallerParaFicha.latitud},${tallerParaFicha.longitud}` : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent((tallerParaFicha.nombre + ' ' + (tallerParaFicha.ciudad||'')).trim() + ', Colombia')}&travelmode=driving`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 py-3 bg-green-500/20 text-green-400 hover:bg-green-500 hover:text-white border border-green-500/40 rounded-xl text-[11px] font-black uppercase tracking-widest flex items-center justify-center gap-1.5 transition-all shadow-inner"
                        >
                           🗺️ Ir con Maps
                        </a>
                    </div>
                  </div>
                  )}
               </div>

               <button 
                  onClick={() => {
                     setTallerParaCotizar(tallerParaFicha);
                     setModalLicitacionAbierto(true);
                     setTallerParaFicha(null);
                  }}
                  className="w-full py-4 bg-gradient-to-r from-primary-cyan to-blue-600 font-black text-white text-[13px] tracking-wide rounded-xl shadow-lg active:scale-95 transition-all text-center uppercase"
               >
                  Cotizar Directo
               </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
